import styled, { css, DefaultTheme } from 'styled-components';
import { Form as FormikForm } from 'formik';

type FormProps = {
  bgcolor?: 'default' | 'white';
};

const containerModifiers = {
  default: (theme: DefaultTheme) => css`
    background: ${theme.colors.neutralLight20};
  `,
  white: (theme: DefaultTheme) => css`
    background: ${theme.colors.globalWhite100};
  `,
};

export const Container = styled.section<FormProps>`
  ${({ theme, bgcolor }) => css`
    border-radius: 8px;

    padding: 32px 24px;

    width: 100%;

    ${bgcolor && containerModifiers[bgcolor](theme)}
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-weight: 700;
    font-size: 3.2rem;
    color: ${theme.colors.neutralDark80};
    margin-bottom: 32px;

    @media (max-width: 1200px) {
      display: none;
    }
  `}
`;
export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;

  gap: 32px;
`;
